import { render, staticRenderFns } from "./MultipurposeRoom.vue?vue&type=template&id=656a389a&scoped=true"
import script from "./MultipurposeRoom.vue?vue&type=script&lang=js"
export * from "./MultipurposeRoom.vue?vue&type=script&lang=js"
import style0 from "./MultipurposeRoom.vue?vue&type=style&index=0&id=656a389a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656a389a",
  null
  
)

export default component.exports